<div class="flex justify-center items-center w-full h-full ">
  <div class="flex flex-col items-center w-full max-w-[400px] ">
    <img
      class="w-[40%] pointer-events-none mb-5"
      src="/assets/ios-publishing-empty-state.png"
      alt=""
    />
    <h1 class="text-2xl text-center font-bold mb-[10px]">
      {{ 'ios-publishing-empty-state.title' | translate }}
    </h1>
    <p class="opacity-70 text-centermt-2 mb-[30px]">
      {{ 'ios-publishing-empty-state.desc' | translate }}
    </p>
    <rk-button
      (buttonClick)="upgradeOffer()"
      [text]="'ios-publishing-empty-state.cta' | translate"
    ></rk-button>
  </div>
</div>
